<template>
  <div>
    <div class="uk-width-1-1" :class="{ 'dcs-has-error': hasError }">
      <div class="uk-form-controls">
        <label>
          <input
            type="radio"
            class="uk-radio"
            name="request_type"
            value="access"
            :checked="requestType == 'access'"
            @change="$emit('update:requestType', 'access')"
          />
          <template v-if="law == 'ccpa'"> Access My Data</template>
          <template v-else-if="law == 'ocpa'"> Obtain my personal data</template>
        </label>
      </div>
      <div class="">
        <label>
          <input
            type="radio"
            class="uk-radio"
            name="request_type"
            value="removal"
            :checked="requestType == 'removal'"
            @change="$emit('update:requestType', 'removal')"
          />
          <template v-if="law == 'ccpa'"> Delete My Data</template>
          <template v-else-if="law == 'ocpa'"> Delete my personal data</template>
        </label>
      </div>
      <div class="">
        <label>
          <input
            type="radio"
            class="uk-radio"
            name="request_type"
            value="correction"
            :checked="requestType == 'correction'"
            @change="$emit('update:requestType', 'correction')"
          />
          <template v-if="law == 'ccpa'"> Correct My Data</template>
          <template v-else-if="law == 'ocpa'"> Correct my personal data</template>
        </label>
      </div>

      <div v-if="law == 'ocpa'" class="">
        <label>
          <input
            type="radio"
            class="uk-radio"
            name="request_type"
            value="Opt Out"
            :checked="requestType == 'opt-out'"
            @change="$emit('update:requestType', 'opt-out')"
          />
          Opt out of processing my personal data
        </label>
      </div>
      <div v-if="law == 'ocpa'" class="">
        <label>
          <input
            type="radio"
            class="uk-radio"
            name="request_type"
            value="list"
            :checked="requestType == 'list-third-party'"
            @change="$emit('update:requestType', 'list-third-party')"
          />
          Obtain list of third parties to which {{ formattedBrand }} disclosed personal data
        </label>
      </div>
      <div v-if="law == 'ocpa'" class="">
        <label>
          <input
            type="radio"
            class="uk-radio"
            name="request_type"
            value="confirm"
            :checked="requestType == 'confirm'"
            @change="$emit('update:requestType', 'confirm')"
          />
        Confirm whether {{ formattedBrand }} is processing or has processed your personal data, and the categories of personal data processed
        </label>
        <div class="">
          <label>
            <input
              type="radio"
              class="uk-radio"
              name="request_type"
              value="appeal"
              :checked="requestType == 'appeal'"
              @change="$emit('update:requestType', 'appeal')"
            />
            Appeal the Outcome of My Prior OCPA Request
          </label>
        </div>
      </div>

      <div v-if="requestType == 'appeal'" class="uk-grid uk-grid-small">
        <div class="uk-margin uk-card-small uk-card-default uk-card-body">
          <span class="uk-text-bold">
            To start your appeal of a prior OCPA request, please provide the following information:
          </span>

          <div>
            <div class="">
              <label>Date of Prior Request Submission: </label>
              <input
                :value="previousRequestDate"
                type="date"
                name="previous_request_date"
                class="uk-input dcs-input"
                @change="$emit('update:previousRequestDate', $event.target.value)"
              />
            </div>
            <div class="radio-group uk-margin-small-top">
              <label for="appealGroup"> Type of Prior Request: </label>
              <label>
                <input
                  :value="access"
                  type="radio"
                  name="appeal_type"
                  class="uk-radio"
                  @change="$emit('update:appealType', 'access')"
                />
              Obtain my personal data
              </label>
              <label>
              <input
                :value="removal"
                type="radio"
                name="appeal_type"
                class="uk-radio"
                @change="$emit('update:appealType', 'removal')"
              />
              Delete my personal data
            </label>
              <label>
              <input
                :value="correction"
                type="radio"
                name="appeal_type"
                class="uk-radio"
                @change="$emit('update:appealType', 'correction')"
              />
              Correct my personal data
            </label>
              <label>
              <input
                :value="opt_out"
                type="radio"
                name="appeal_type"
                class="uk-radio"
                @change="$emit('update:appealType', 'opt_out')"
              />
              Opt out of processing my personal data
            </label>

              <label>
              <input
                :value="list_third_party"
                type="radio"
                name="appeal_type"
                class="uk-radio"
                @change="$emit('update:appealType', 'list_third_party')"
              />
              Obtain list of third parties to which {{ formattedBrand }} disclosed personal data
            </label>

              <label>
              <input
                :value="confirm"
                type="radio"
                name="appeal_type"
                class="uk-radio"
                @change="$emit('update:appealType', 'confirm')"
              />
              Confirm whether {{ formattedBrand }} is processing or has processed your personal data, and the categories of personal data processed
            </label>
            </div>
            <div class="">
              <label>Description of Your Appeal: </label>
              <textarea
                :value="appealReason"
                maxlength="5000"
                name="appeal_reason"
                class="uk-textarea dcs-input"
                @change="$emit('update:appealReason', $event.target.value)"
              />
            </div>
          </div>
        </div>
      </div>
   </div>
  </div>
</template>



<script>


export default {
  name: "request-type",
  props: ["requestType", "hasError", "law", "brand", "appealType", "appealReason", "previousRequestDate"],
  computed: {
    formattedBrand() {
      if (this.brand === 'netcredit') {
        return 'NetCredit';
      }

      if (this.brand === 'cnu') {
        return 'CashNetUSA';
      }

      return this.brand;
    }
  },
}

</script>

<style scoped></style>

<style>
    .radio-group {
        margin-bottom: 20px;
    }
    .radio-group label {
        display: block;
        margin-bottom: 5px;
    }
</style>
